@if (control) {
  <mat-form-field>
    @if (label()) {
      <label
        [for]="inputId"
        [ngClass]="{ 'text-red': control.invalid && (control.dirty || control.touched) }"
      >
        <span
          >{{ label() }}
          @if (isRequired && !hideRequiredMarker()) {
            <span class="required">*</span>
          }
        </span>
      </label>
    }
    <mat-select
      [id]="inputId"
      [placeholder]="placeholder()"
      [multiple]="multiple()"
      [formControl]="control"
      [aria-label]="ariaLabel() || label() || ''"
      [attr.aria-describedby]="showError ? errorId : null"
      disableOptionCentering
    >
      @for (option of options(); track option.id) {
        <mat-option [value]="option.id">{{ option.name }}</mat-option>
      }
      <ng-content></ng-content>
    </mat-select>
    @if (showError) {
      <mat-error [id]="errorId">{{ getErrorMessage(errorKeys[0]) }}</mat-error>
    }
  </mat-form-field>
}
